import { useRef, useCallback } from 'react';

/**
 * useSwipe — detects horizontal swipe gestures on a ref'd element.
 * @param {function} onSwipeLeft  — called when user swipes left (next)
 * @param {function} onSwipeRight — called when user swipes right (previous)
 * @param {number}   threshold   — min px to count as a swipe (default 60)
 */
const useSwipe = (onSwipeLeft, onSwipeRight, threshold = 60) => {
  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  const onTouchStart = useCallback((e) => {
    touchStartX.current = e.touches[0].clientX;
    touchStartY.current = e.touches[0].clientY;
  }, []);

  const onTouchEnd = useCallback((e) => {
    if (touchStartX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    const dy = e.changedTouches[0].clientY - touchStartY.current;

    // Only count horizontal swipes (ignore scrolls)
    if (Math.abs(dx) < Math.abs(dy) * 1.5) return;
    if (Math.abs(dx) < threshold) return;

    if (dx < 0) onSwipeLeft?.();   // swipe left → next
    else         onSwipeRight?.();  // swipe right → prev

    touchStartX.current = null;
    touchStartY.current = null;
  }, [onSwipeLeft, onSwipeRight, threshold]);

  return { onTouchStart, onTouchEnd };
};

export default useSwipe;
